export default __webpack_public_path__ + "static/media/mini-secured-card@2x.c5cb903f.png";